export default __webpack_public_path__ + "static/media/logo.b533cd98.svg";